"use client";

import { c as _c } from "react/compiler-runtime";
import { useDesktopAnimations } from "@/lib/breakpoints";
import React from "react";
import { motion } from "framer-motion";
import Image from "next/image";
import { userSegments } from "./crm.data";
const ease = [0.17, 0.85, 0.438, 0.99] as const;
export default function UserSegments() {
  const $ = _c(22);
  const desktopAnimations = useDesktopAnimations();
  let t0;
  if ($[0] !== desktopAnimations) {
    t0 = desktopAnimations ? {
      opacity: 0,
      y: 40
    } : false;
    $[0] = desktopAnimations;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== desktopAnimations) {
    t1 = desktopAnimations ? {
      opacity: 1,
      y: 0
    } : undefined;
    $[2] = desktopAnimations;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== desktopAnimations) {
    t2 = desktopAnimations ? undefined : {
      opacity: 1,
      y: 0
    };
    $[4] = desktopAnimations;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      duration: 0.6,
      ease
    };
    t4 = {
      once: true
    };
    $[6] = t3;
    $[7] = t4;
  } else {
    t3 = $[6];
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t0 || $[9] !== t1 || $[10] !== t2) {
    t5 = <motion.h2 initial={t0} whileInView={t1} animate={t2} transition={t3} viewport={t4} className="font-poppins mb-5 text-[30px] font-bold leading-[1.35] text-[#141047] sm:text-[36px] lg:text-[40px] dark:text-white">CRM Designed for All Healthcare Professionals to Simplify Practice Management</motion.h2>;
    $[8] = t0;
    $[9] = t1;
    $[10] = t2;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <p className="mx-auto max-w-[800px] text-[16px] leading-[28px] text-[#6b7280] dark:text-gray-400">Our CRM helps doctors and clinics manage appointments, patient records, and daily tasks easily, making work simple and improving patient care.</p>;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t5) {
    t7 = <div className="mx-auto mb-14 max-w-[820px] text-center">{t5}{t6}</div>;
    $[13] = t5;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== desktopAnimations) {
    t8 = userSegments.map((segment, idx) => <motion.div key={segment.title} initial={desktopAnimations ? {
      opacity: 0,
      y: 30
    } : false} whileInView={desktopAnimations ? {
      opacity: 1,
      y: 0
    } : undefined} animate={desktopAnimations ? undefined : {
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5,
      delay: idx * 0.1,
      ease
    }} viewport={{
      once: true
    }} className={"\n                group relative flex h-full flex-col overflow-hidden rounded-2xl bg-white p-9\n                text-center border border-gray-100\n                shadow-[0_6px_24px_rgba(0,0,0,0.04)]\n                transition-all duration-300\n                hover:-translate-y-2.5\n                hover:shadow-[0_16px_40px_rgba(0,0,0,0.10)]\n                dark:bg-gray-800 dark:border-gray-700\n              "}><div className="mx-auto mb-6 flex items-center justify-center"><Image src={segment.image} alt={segment.title} width={64} height={64} className="h-16 w-16 object-contain transition-transform duration-300 group-hover:scale-110" /></div><h3 className="font-poppins mb-3 text-[20px] font-bold text-[#141047] dark:text-white">{segment.title}</h3><p className="text-[16px] leading-[26px] text-[#6b7280] dark:text-gray-400">{segment.description}</p><span aria-hidden={true} className="absolute bottom-0 left-0 h-1 w-0 bg-[linear-gradient(135deg,#9100ff_0%,#3663ff_54%,#00e2ff_100%)] transition-[width] ease-[cubic-bezier(0.17,0.85,0.438,0.99)] duration-[1200ms] group-hover:w-full" /></motion.div>);
    $[15] = desktopAnimations;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t8) {
    t9 = <div className="grid grid-cols-1 items-stretch gap-6 md:grid-cols-3 md:gap-9">{t8}</div>;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t7 || $[20] !== t9) {
    t10 = <section className="bg-[linear-gradient(to_bottom,#DBF2FF_10%,#FFFFFF_100%)] px-6 py-16 font-sans md:py-24 dark:bg-gray-950 dark:bg-none"><div className="mx-auto w-full max-w-[1290px]">{t7}{t9}</div></section>;
    $[19] = t7;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  return t10;
}